import React, { useEffect, useState } from 'react';
import { config, PERMISSIONS } from '../../../../config';
import axiosApi from '../../../../core/interceptor/interceptor';
import DataTableComponent from '../../../../Util/DataTable/DataTable';
import { loadColumns } from '../../../../Util/helper';
import { withRouter } from 'react-router-dom';
import Tab from '../../../../Util/Tabs/Tab';
import { AsyncPaginate } from 'react-select-async-paginate';
import './AdminTransaction.css';
import WarningDialogue from '../../../../Util/WarningDialogue';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { permissions } from '../../../../Store/reducers/PermissionsReducer.js';
import { useSelector } from 'react-redux';

const indvColumns = [
  {
    name: 'Season',
    selector: 'league.season.name',
  },
  {
    name: 'League',
    selector: 'league.name',
    type: 'transaction_from'
  },
  {
    name: 'Name',
    selector: 'user.name',
  },
  {
    name: 'Transaction Id',
    selector: 'transaction_id'
  },
  {
    name: 'Reg Fee',
    selector: 'registration_fees'
  },
  {
    name: 'Stripe Fee',
    selector: 'stripe_fees'
  },
  {
    name: 'Total Fee',
    selector: 'total_fees',
  },
  {
    name: 'Card',
    selector: 'isCard',
    type: 'checked-i',
  },
  {
    name: 'Payment Status',
    selector: 'payment_status',
    type: 'status',
  },
  // {
  //   name: 'Action',
  //   type: 'table_action',
  //   for: 'indv',
  //   selector: 'is_refunded',
  //   actionHandler: function (e) {
  //     console.log('Event ----->', e);
  //   },
  // }
];

const eventColumns = [
  {
    name: 'Event',
    selector: 'event.title',
  },
  {
    name: 'Name',
    selector: 'user.name',
  },
  {
    name: 'Type',
    selector: 'type'
  },
  {
    name: 'Transaction Id',
    selector: 'transaction_id'
  },
  {
    name: 'Amount',
    selector: 'amount'
  },
  {
    name: 'Stripe Fee',
    selector: 'stripe_fee'
  },
  {
    name: 'Total Amount',
    selector: 'total_amount',
  },
  {
    name: 'Payment Status',
    selector: 'status',
    type: 'status',
  },
];

const tabs = [
  {
    name: "Team Transaction",
    url: "/team"
  },
  {
    name: "Individual Transaction",
    url: "/individual"
  },
  {
    name: 'Event Transaction',
    url: '/event'
  }
];

function AdminTransaction(props) {
  const permission = useSelector(permissions);
  const [data, setData] = useState([]);
  const [individuals, setIndividuals] = useState([]);
  const [filter, setFilter] = useState({
    limit: 50,
    page: 1,
    direction: 'desc',
    searchString: '',
    sort_column: 'id',
  })
  const [totalData, setTotalData] = useState(0);
  const [totalIndividuals, setTotalIndividuals] = useState(0);
  const [selectedTab, setSelectedTab] = useState('');
  const [selectedSeason, setSelectedSeason] = useState(null);
  // eslint-disable-next-line
  const [seasonFilter, setSeasonFilter] = useState({ page: 1, search: '' });
  // eslint-disable-next-line
  const [leagueFilter, setLeagueFilter] = useState({ page: 1, search: '' });
  const [selectedLeagues, setSelectedLeague] = useState(null);
  const [openWarning, setOpenWarning] = useState(false);
  const [selectedForfeit, setSelectedforfeit] = useState(null);
  const [columns, setColumns] = useState([]);
  const [eventTransactions, setEventTransactions] = useState([]);
  const [totalEventTransaction, setTotalEventTransaction] = useState(0);

  useEffect(() => {
    const url = `/${props?.location?.pathname?.split('/').pop()}`;
    if (url === '/individual') {
      setSelectedTab(`/${props?.location?.pathname?.split('/').pop()}`)
      if (props?.location?.state?.search_string) {
        setFilter((prev) => ({ ...prev, searchString: (props?.location?.state?.search_string || '').toString().trim(), sort_column: 'id', direction: 'desc', }));
      }
    } else if (url === '/event') {
      setSelectedTab('/event');
    } else {
      setSelectedTab('/team');
      setFilter((prev) => ({ ...prev, sort_column: 'id' }));
    }
  }, [props?.location?.pathname, props?.location?.state?.search_string]);

  useEffect(() => {
    if (selectedTab === '/individual') {
      getIndividuals(filter);
    }
    if (selectedTab === '/team') {
      getTeams(filter)
    }
    if (selectedTab === '/event') {
      getEvents(filter);
    }
    // eslint-disable-next-line
  }, [
    filter.sort_column,
    filter.page,
    filter.direction,
    filter.limit,
    selectedTab,
    selectedSeason,
    selectedLeagues,
  ]);

  useEffect(() => {
    const orrColumns = [
      {
        name: 'Season',
        selector: 'league.season.name',
      },
      {
        name: 'League',
        selector: 'league.name',
        type: 'transaction_from'
      },
      {
        name: 'Team',
        selector: 'name',
      },
      {
        name: 'Captain',
        selector: 'user.name',
      },
      {
        name: 'Transaction Id',
        selector: 'transaction_id'
      },
      {
        name: 'Reg Fee',
        selector: 'registration_fees'
      },
      {
        name: 'Forfeit Fee',
        selector: 'for_feit_fees'
      },
      {
        name: 'Stripe Fee',
        selector: 'stripe_fees'
      },
      {
        name: 'Total Fee',
        selector: 'total_fees',
      },
      {
        name: 'Card',
        selector: 'isCard',
        type: 'checked-i',
      },
      {
        name: 'Status',
        selector: 'payment_status',
        type: 'status',
      },
      {
        name: 'Refund Amount',
        selector: 'refundableAmounts',
        type: 'refundableAmounts',
        sortable: false,
      },
    ]
    const tmpCol = [...orrColumns];
    if (Array.isArray(permission) && permission.includes(PERMISSIONS.REFUND_FORFEIT)) {
      tmpCol.push({
        name: 'Action',
        type: 'table_action',
        selector: 'is_refunded',
        actionHandler: function (e) {
          setSelectedforfeit(e);
          setOpenWarning(true);
        },
      });
    }
    setColumns(tmpCol);
  }, [permission]);

  function getTeams(params) {
    axiosApi.post(`${config.apiUrl}/transactions/team`,
      {
        ...params,
        // league_ids: (selectedLeagues || []).map(league => league.id),
        // season_ids: (selectedSeason || []).map(season => season.id),
        league_ids: selectedLeagues?.id ? [selectedLeagues.id] : [],
        season_ids: selectedSeason?.id ? [selectedSeason.id] : [],
      }
    ).then((resp) => {
      if (resp && resp.data && resp.data.data && resp.data.data.rows) {
        setData(resp.data.data.rows);
        setTotalData(resp.data.data?.count);
      }
    });
  }

  function getIndividuals(params) {
    axiosApi.post(`${config.apiUrl}/transactions/individual`,
      {
        ...params,
        // league_ids: (selectedLeagues || []).map(league => league.id),
        // season_ids: (selectedSeason || []).map(season => season.id),
        league_ids: selectedLeagues?.id ? [selectedLeagues.id] : [],
        season_ids: selectedSeason?.id ? [selectedSeason.id] : [],
      },
    ).then((resp) => {
      if (resp && resp.data && resp.data.data && resp.data.data.rows) {
        setIndividuals(resp.data.data.rows);
        setTotalIndividuals(resp.data.data?.count);
      }
    });
  }

  /**
   * 
   * Event Transactions 
   */
  const getEvents = (params) => {
    axiosApi.get(`${config.apiUrl}/transactions/event`, { params })
    .then((resp) => {
      if (resp && resp.data && resp.data.data && resp.data.data) {
        setEventTransactions(resp.data.data);
        setTotalEventTransaction(resp.data.data?.length);
      }
    })
  }

  const handleChangeTable = (e) => {
    if (e.type === 'sort') {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          [e.target.name]: e.target.value,
          direction: e.target.direction,
        };
        return filter_;
      });
    } else {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          page: 1,
          sort_column: 'id',
          direction: 'desc',
          [e.target.name]: e.target.value,
        };
        return filter_;
      })
    }
  }

  const search = () => {
    if (selectedTab === '/team') {
      getTeams({ ...filter, 'searchString': filter.searchString.trim(), page: 1 });
    }
    if (selectedTab === '/individual') {
      getIndividuals({ ...filter, 'searchString': filter.searchString.trim(), page: 1 });
    }
    if (selectedTab === '/event') {
      getEvents({ ...filter, 'searchString': filter.searchString.trim(), page: 1 })
    }
  }

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      lineHeight: "16px",
      wordBreak: "break-word",
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer"
    })
  }

  const getAllSeasons = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/seasons`, { params: { page: page_, search: searchString } });
    return seasons.data.data;
  }

  const getLeagues = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/misc/leagues/${selectedSeason?.id || 0}`, { params: { page: page_, search_string: searchString } });
    return seasons.data.data;
  }

  const loadOptionsSeason = async (searchQuery, loadedOptions, { page }) => {
    setSeasonFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const seasons = await getAllSeasons(page, searchQuery);
    return {
      options: seasons,
      hasMore: seasons.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsLeague = async (searchQuery, loadedOptions, { page }) => {
    setLeagueFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const leagues = await getLeagues(page, searchQuery);
    return {
      options: leagues,
      hasMore: leagues.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const refundForfeit = (data) => {
    axiosApi.get(`${config.apiUrl}/leagues/refund-amount/${data.id}`).then((resp) => {
      if (selectedTab === '/individual') {
        getIndividuals(filter);
      } else {
        getTeams(filter);
      }
      setOpenWarning(false);
    }).catch((err) => {
      setOpenWarning(false);;
    });
  }

  return (
    <>
      <div id="transactions-admin" className="content-wrapper leagues-wrapper">
        <div className="league-wrapper">
          <div className="heading-wrapper transactions-head">
            <h2>Transactions</h2>
          </div>
          <Tab tabs={tabs} emit={(e) => {
            setFilter((prev) => {
              const filter_ = {
                limit: 50,
                page: 1,
                sort_column: 'id',
                direction: 'desc',
                searchString: '',
              };
              setSelectedTab((prevTab) => {
                if (prevTab !== e) {
                  setData([]);
                  setIndividuals([]);
                  setLeagueFilter({ page: 1, search: '' });
                  setSeasonFilter({ page: 1, search: '' });
                  setSelectedLeague([]);
                  setSelectedSeason([]);
                }
                return e;
              });
              return filter_;
            });
          }}
          />
          <div className='table-wrapper'>
            <div className="search-blk league-search resp-search">
              <h2>Transaction Filters</h2>
              <div className="input-blk">
                <div className="search-bar">
                  <div className="input-field">
                    <label>Search</label>
                    <input type="text" id="search_bar" name="search" placeholder={selectedTab === '/team' ? 'Search by Team, Captain, Transaction Id...' : 'Search by Name, Transaction Id, Payment Status...'} value={filter.searchString} onChange={(e) => setFilter(prev => ({ ...prev, searchString: e.target.value }))} />
                  </div>
                  <button type='submit' onClick={search}>Search</button>
                </div>
                {selectedTab !== '/event' && <div className="drop-wrapper">
                  <div className="drop-down">
                    <label>Season</label>
                    <AsyncPaginate
                      isClearable={true}
                      value={selectedSeason}
                      classNamePrefix="cs-new-dropdown"
                      loadOptions={loadOptionsSeason}
                      getOptionValue={(option) => option.id}
                      getOptionLabel={(option) => option.name}
                      onChange={(option) => {
                        setSelectedSeason(option);
                      }}
                      placeholder="Select Season"
                      additional={{
                        page: 1,
                      }}
                      debounceTimeout={1000}
                      styles={customStyles}
                      noOptionsMessage={() => "No Seasons Found."}
                      className="multivalue-dropdown"
                    // closeMenuOnSelect={false}
                    />
                  </div>
                  <div className="drop-down">
                    <label>League</label>
                    <AsyncPaginate
                      key={selectedSeason?.id}
                      classNamePrefix="cs-new-dropdown"
                      isClearable={true}
                      value={selectedLeagues}
                      loadOptions={loadOptionsLeague}
                      getOptionValue={(option) => option.id}
                      getOptionLabel={(option) => option.name}
                      onChange={(option) => {
                        setSelectedLeague(option);
                      }}
                      placeholder="Select League"
                      additional={{
                        page: 1,
                      }}
                      debounceTimeout={1000}
                      styles={customStyles}
                      noOptionsMessage={() => "No Leagues Found."}
                      className="multivalue-dropdown"
                    // closeMenuOnSelect={false}
                    />
                  </div>
                </div>}
              </div>
            </div>
            <div className="heading-blk">
              <div className="left">
                <h2>Results</h2>
                <p>All Transactions of Mulberry{selectedTab === '/event'? ' Events' : ' and Cleveland'}.</p>
              </div>
            </div>
            <div className='dataTable active'>
              <DataTableComponent
                data={selectedTab === '/team' ? data : selectedTab === '/individual' ? individuals : eventTransactions}
                columns={loadColumns(selectedTab === '/team' ? { columns } : selectedTab === '/individual' ? { columns: indvColumns } : { columns: eventColumns})}
                onFilterChange={handleChangeTable}
                totalPage={selectedTab === '/team' ? totalData : selectedTab === '/individual' ? totalIndividuals : totalEventTransaction}
                disableRowClicked={true}
              />
            </div>
          </div>
        </div>
      </div>
      <WarningDialogue
        isOpen={openWarning}
        header={'Warning'}
        description={`Are you sure, you want to refund forfeit fee?`}
        icon={faExclamationTriangle}
        data={selectedForfeit}
        action={(data) => {
          refundForfeit(data);
        }}
        onClose={(e) => {
          setSelectedforfeit(null);
          setOpenWarning(false)
        }}
      />
    </>
  )
}

export default withRouter(AdminTransaction);

